import "core-js/modules/es.array.push.js";
const CHARTLIST = [{
  key: 'ANNULAR',
  name: '环形占比图'
}, {
  key: 'BAR',
  name: '条形占比图'
}, {
  key: 'BROKEN_LINE',
  name: '折线图'
}, {
  key: 'COLUMNAR',
  name: '柱状图'
}, {
  key: 'TOP_LIST',
  name: 'top榜'
}
// {key: 'MAP', name: '地图'}
];
const CARDLIST = [{
  key: 'MULTI_CARD',
  name: '多卡片统计卡'
}, {
  key: 'SINGLE_CARD',
  name: '单卡片统计卡'
}];
const Mock = require('mockjs');
function rankData() {
  let obj = Mock.mock({
    'name|10': {
      保险1: '@natural(20,2000)',
      保险2: '@natural(20,2000)',
      保险3: '@natural(20,2000)',
      保险4: '@natural(20,2000)',
      保险5: '@natural(20,2000)',
      保险6: '@natural(20,2000)',
      保险7: '@natural(20,2000)',
      保险8: '@natural(20,2000)',
      保险9: '@natural(20,2000)',
      保险10: '@natural(20,2000)',
      保险11: '@natural(20,2000)',
      保险12: '@natural(20,2000)'
    }
  });
  let list = [];
  for (let i in obj.name) {
    list.push({
      area: i,
      value: obj.name[i]
    });
  }
  return list.sort((a, b) => {
    return b.value - a.value;
  });
}
export { CHARTLIST, CARDLIST, rankData };